// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import $ from 'jquery';
import toastr from 'packs/theme/toastr'
window.jQuery = $;
window.$ = $;
window.toastr = toastr;

import 'core-js/stable'
import 'regenerator-runtime/runtime'

require("@rails/ujs").start()
require("@rails/activestorage").start()


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import 'stylesheets/application'

import 'packs/user_session'
import 'bootstrap'
import 'packs/theme/polyfills'
import 'material-ripple/dist/ripple'
import 'packs/theme/layout-helpers'
import 'pace'
import 'perfect-scrollbar'
import 'packs/theme/sidenav'
import 'chartjs'
import 'cocoon'
import select2 from 'select2'
import 'packs/theme/demo'
import 'packs/datatables-config'
import 'packs/theme/dropzone'
//import 'packs/theme/nestable'
import 'bootstrap-datepicker'
import 'packs/nsi/forms'
import 'packs/init'
import 'packs/filelist'
import 'packs/utils'
import 'packs/theme/landing'
import 'packs/portals/ticket'
import 'packs/portals/ai_data_request'
import 'packs/libs/cadesplugin_api'
import 'packs/signature'
import 'packs/stateful'

import tinymce from 'tinymce/tinymce';
import 'tinymce/icons/default';
import 'tinymce/themes/silver';
import 'tinymce/plugins/paste';
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/link';
import 'tinymce/plugins/image';
import 'tinymce/plugins/charmap';
import 'tinymce/plugins/print';
import 'tinymce/plugins/preview';
import 'tinymce/plugins/anchor';
import 'tinymce/plugins/searchreplace';
import 'tinymce/plugins/visualblocks';
import 'tinymce/plugins/code';
import 'tinymce/plugins/fullscreen';
import 'tinymce/plugins/insertdatetime';
import 'tinymce/plugins/media';
import 'tinymce/plugins/table';
import 'tinymce/plugins/paste';
import 'packs/tinymce/tinymce_config'
import 'packs/tinymce/langs/ru'
